import { ActionDefinition } from "~/types/actions";

/**
 * Shared table-level actions.
 * These actions are available in both CharacterSheet and GmView.
 */
export const getTableActions = (): ActionDefinition[] => [
  {
    id: "open-table-search",
    label: "Switch Table",
    description: "Open table switcher",
    keywords: ["switch", "table", "change", "select", "campaign"],
    category: "navigation",
  },
  {
    id: "move-character-to-table",
    label: "Move Character to Table",
    description: "Move the current character to a different table",
    keywords: ["move", "character", "table", "transfer", "assign"],
    category: "navigation",
  },
  {
    id: "delete-table",
    label: "Delete Table",
    description: "Delete the current table (characters move to Uncategorized)",
    keywords: ["delete", "remove", "table", "campaign"],
    category: "navigation",
  },
  {
    id: "rename-table",
    label: "Rename Table",
    description: "Rename the current table",
    keywords: ["rename", "table", "edit", "name", "campaign"],
    category: "navigation",
  },
  {
    id: "import-character-from-table",
    label: "Import Character from Another Table",
    description: "Copy a character from another table to this table",
    keywords: ["import", "copy", "character", "table", "duplicate"],
    category: "navigation",
  },
];
